import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import Access from "./Access"; // Assuming Access is in the same directory
import { Authorization } from "../../../Context/Authorization";
const EditUser = ({ user, onClose, onEditUser }) => {
  const [username, setUsername] = useState(user.username);
  const [name, setName] = useState(user.name);
  const [designation, setDesignation] = useState(user.designation);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState(user.email);
  const [role, setRole] = useState(user.role._id);
  const [roles, setRoles] = useState([]);
  const [access, setAccess] = useState(user.access || {});
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState("");
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchRoles = async () => {
      const Confiq = Authorization();
      try {
        const response = await axios.get(`${Api}/api/users/roles`, Confiq);
        setRoles(response.data);
      } catch (error) {
        console.error("Error fetching roles", error);
        toast.error("Error fetching roles");
      }
    };
    fetchRoles();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!username) newErrors.username = "Username is required";
    if (!name) newErrors.name = "Name is required";
    if (!designation) newErrors.designation = "Designation is required";
    if (!email) newErrors.email = "Email is required";
    if (!role) newErrors.role = "Role is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }
    setSubmitMessage("User Successfully Edited!");

    const formData = { username, name, designation, email, role, access };
    if (password) formData.password = password;

    try {
      const Confiq = Authorization();
      const response = await axios.put(
        `${Api}/api/users/user/${user._id}`,
        formData,
        Confiq
      );
      if (response.status === 200) {
        toast.success("User edited successfully");
        onEditUser(response.data);
        onClose();
      } else {
        toast.error("Error editing user");
      }
    } catch (error) {
      console.error("Error editing user", error);
      toast.error("Error editing user");
    }
  };

  const handleOpenAccessModal = () => {
    setShowAccessModal(true);
  };

  const handleCloseAccessModal = () => {
    setShowAccessModal(false);
  };

  return (
    <div className="userForm">
      <Modal show onHide={onClose} centered>
        {submitMessage && <Alert variant="info">{submitMessage}</Alert>}
        <Modal.Header>
          <Modal.Title>Edit User</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  isInvalid={!!errors.name}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formDesignation">
              <Form.Label>Designation</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter designation"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  isInvalid={!!errors.designation}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.designation}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  isInvalid={!!errors.username}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.username}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="password"
                  placeholder="Enter password (leave blank to keep current password)"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  isInvalid={!!errors.password}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  isInvalid={!!errors.email}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRole">
              <Form.Label>Role</Form.Label>
              <div className="input-container">
                <Form.Control
                  as="select"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  isInvalid={!!errors.role}
                >
                  <option value="">Select Role</option>
                  {roles.map((role) => (
                    <option key={role._id} value={role._id}>
                      {role.roleName}
                    </option>
                  ))}
                </Form.Control>
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.role}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Button to open access modal */}
            <Button
              variant="primary"
              onClick={handleOpenAccessModal}
              className="mt-3"
            >
              Edit Access
            </Button>

            <Button type="submit" className="mt-3" variant="success">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Access Modal */}
      <Access
        show={showAccessModal}
        onHide={handleCloseAccessModal}
        setAccess={setAccess}
        access={access} // Pass current access state
      />
    </div>
  );
};

export default EditUser;
